import { render, staticRenderFns } from "./OrderCustomerDetail.vue?vue&type=template&id=77767d58&"
import script from "./OrderCustomerDetail.vue?vue&type=script&lang=js&"
export * from "./OrderCustomerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports